import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class RoyaltyService extends RLBaseService {
    static $inject = ["$resource", "$q"];

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
        super($resource);
    }

    getRoyaltyStatements(request: Models.IGetRoyaltyStatementsRequest) {
        return this.toRLService<Models.IGetRoyaltyStatementsResponse>("/api/royaltystatement/getroyaltystatements").post(request).$promise;
    }

    getRoyaltyStatement(request: Models.IGetRoyaltyStatementsRequest) {
        return this.toRLService<Models.IGetRoyaltyRecipientResponse>("/api/royaltystatement/getroyaltystatement").post(request).$promise;
    }

    exportRoyaltyStatement(request: Models.IGetRoyaltyStatementsRequest) {
        return this.toRLService<Models.IExportRoyaltyStatementResponse>("/api/royaltystatement/exportroyaltystatement").post(request).$promise;
    }
}
